import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "form",
  initialState: {
    submissions: []
  },
  reducers: {
    addSubmission: (state, action) => {
      state.submissions.push(action.payload);
    }
  }
});

export const { addSubmission } = formSlice.actions;
export default formSlice.reducer;